import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import AdminDashboard from "./AdminDashboard"
import InspectionDashboard from "./InspectionDashboard"
// import HeadQuartersDashboard from "./HeadQuartersDashboard"
import { getProfile } from "store/actions"
import { useRole, ROLE_TYPES } from "hooks/useRole"

const Dashboard = () => {
  const dispatch = useDispatch()
  const { isRole, isAnyRole, currentRole } = useRole()

  useEffect(() => {
    dispatch(getProfile())
  }, [dispatch])

  if (isRole(ROLE_TYPES.INSPECTION_USER)) {
    return <InspectionDashboard />
  }

  // if (isAnyRole([ROLE_TYPES.SUPER_ADMIN])) {
  //   return <HeadQuartersDashboard />
  // }

  if (
    isAnyRole([
      ROLE_TYPES.ADMIN,
      ROLE_TYPES.MANAGING_DIRECTOR,
      ROLE_TYPES.GENERAL_MANAGER,
      ROLE_TYPES.SUPER_ADMIN
    ])
  ) {
    return <AdminDashboard />
  }

  if (currentRole) {
    return <AdminDashboard />
  }
  return null
}

export default Dashboard
